<div class="customPanel">
  <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
    {{this.localiser.get("project.delete")}}
  </h1>

  <div mat-dialog-content class="bodyForm">
    <div *ngIf="!deleteItem" class="row rowForm">
      <div class="col">
        <h4 class="textS+">{{this.localiser.get("devices.project")}}</h4>
        <mat-select class="selectItem textS" [(ngModel)]="selectedItem">
          <mat-option class="textS" *ngFor="let item of dataList" [value]="item">{{item.nombre}}</mat-option>
        </mat-select>
      </div>
    </div>


    <div *ngIf="deleteItem" mat-dialog-content class="bodyForm">

      <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
        {{this.localiser.get("project.delete.sure")}}:
      </h1>

      <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
        {{this.localiser.get("devices.name")}}: {{selectedItem.nombre}}
      </h1>

      <h1 class="textM" style="text-align: center; height: 7%" mat-dialog-title>
        ID: {{selectedItem.idProyecto}}
      </h1>
    </div>

    <div mat-dialog-actions>
      <div class="col" *ngIf="!deleting" style="text-align: center">
        <button class="customButtonColor textS+" mat-button (click)="onCancelClick()">{{this.localiser.get("devices.cancel")}}</button>
      </div>

      <div class="col" *ngIf="!deleting && deleteItem" style="text-align: center">
        <button class="customButtonColor textS+" mat-button (click)="goBack()">{{this.localiser.get("button.back")}}</button>
      </div>

      <div class="col" *ngIf="!deleting" style="text-align: center">
        <button class="customButtonColorDelete textS+" [disabled]="!selectedItem" mat-button (click)="delete()">{{this.localiser.get("button.delete")}}</button>
      </div>

      <div class="col" *ngIf="deleting" style="text-align: center">
        <mat-progress-spinner class="spinner" color="primary" mode="indeterminate" diameter="40">
        </mat-progress-spinner>
      </div>

    </div>

  </div>
</div>
